import { ReactNode, RefObject, FC } from "react";

import { Skeleton, Stack } from "@mui/material";

import { LiveEditorStepLayout } from "../LiveEditorStepLayout/LiveEditorStepLayout";

import { Display } from "@/components/Display/Display";

export interface StepContainerProps {
  children: ReactNode;
  title?: string;
  titleTooltip?: string;
  description?: string | ReactNode;
  isStepChanging: boolean;
  formContainerRef?: RefObject<HTMLDivElement | null>;
  slots: {
    actionFooter: ReactNode;
  };
  "data-test"?: string;
}

export const StepContainer: FC<StepContainerProps> = ({
  children,
  title,
  titleTooltip,
  description,
  isStepChanging,
  formContainerRef,
  slots,
  "data-test": dataTest,
}) => {
  return (
    <>
      {slots.actionFooter}
      <LiveEditorStepLayout
        slots={{
          content: (
            <>
              {/* Step Content */}
              <Display when={!isStepChanging}>{children}</Display>
              <Display when={isStepChanging}>
                <Stack spacing={2}>
                  <Skeleton variant="rounded" height={70} animation="wave" sx={{ bgcolor: "rgba(0, 0, 0, 0.04)" }} />
                  <Skeleton variant="rounded" height={90} animation="wave" sx={{ bgcolor: "rgba(0, 0, 0, 0.04)" }} />
                </Stack>
              </Display>
            </>
          ),
        }}
        title={title}
        titleTooltip={titleTooltip}
        description={description}
        data-test={dataTest}
        formContainerRef={formContainerRef}
      />
    </>
  );
};
